var Extra = /** @class */ (function () {
    function Extra(props) {
        Object.assign(this, props);
    }
    return Extra;
}());
export default Extra;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Extras/Extra.ts
// module id = 729
// module chunks = 0